import * as React from "react";

export const ShareWithMeBigIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="23" fill="none" viewBox="0 0 21 23">
    <g clipPath="url(#clip0_21718_19532)">
      <g
        stroke="#113357"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        clipPath="url(#clip1_21718_19532)"
      >
        <path d="M5.667 5.583a4.333 4.333 0 1 0 8.666 0 4.333 4.333 0 0 0-8.666 0M3.5 20.75v-2.167a4.333 4.333 0 0 1 4.333-4.333h3.25"></path>
        <path d="M16.314 15.52a4.33 4.33 0 0 0-3.064-1.27H10M19.75 16.417l-5.417 5.416M14.333 18.945v2.888h2.89"></path>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_21718_19532">
        <path fill="#fff" d="M0 0h21v23H0z"></path>
      </clipPath>
      <clipPath id="clip1_21718_19532">
        <path fill="#fff" d="M0 0h21v23H0z"></path>
      </clipPath>
    </defs>
  </svg>
);
